export const DefaultStyles = {
  primaryColor: '#003278',
  secondaryColor: '#c0111f',
  textColor: '#00073b',
  logo: 'https://d18y2pm8p6g6xr.cloudfront.net/images/nationals-logo.png',
}
